import moment from "moment";

export const DateFormat = (inputDateString : string | null) => {
  if (!inputDateString) {
    return ""; // Return empty string or any default value as per your requirement
  }
  // Parse the input date string using moment
  const inputDate = moment(inputDateString, "YYYY/MM/DD");

  // Format the date to "dd/mm/yyyy"
  const formattedDate = inputDate.format("DD/MM/YYYY");

  return formattedDate;
};

export const DateTimeFormat = (inputDateTimeString : string | null) => {
  if (!inputDateTimeString) {
    return ""; // Return empty string or any default value as per your requirement
  }
  // Parse the input date-time string using moment
  const dateTime = moment(inputDateTimeString);

  const formattedDateTime = dateTime.format("DD/MM/YYYY HH:mm:ss A");

  return formattedDateTime;
};
